export default __webpack_public_path__ + "static/media/mallory_mp_compact_light.c7a39b8a.ttf";